/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { AuditStatus } from 'app/shared/model/enumerations/audit-status.model';
import { AuditOutcome } from 'app/shared/model/enumerations/audit-outcome.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-audit-summary.reducer';

export const PharmacyAuditSummaryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyAuditSummaryEntity = useAppSelector(state => state.pharmacyAuditSummary.entity);
  const loading = useAppSelector(state => state.pharmacyAuditSummary.loading);
  const updating = useAppSelector(state => state.pharmacyAuditSummary.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyAuditSummary.updateSuccess);
  const auditStatusValues = Object.keys(AuditStatus);
  const auditOutcomeValues = Object.keys(AuditOutcome);

  const handleClose = () => {
    navigate(`/pharmacy-audit-summary${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacyBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.discrepancyLoss !== undefined && typeof values.discrepancyLoss !== 'number') {
      values.discrepancyLoss = Number(values.discrepancyLoss);
    }
    if (values.discrepancyGain !== undefined && typeof values.discrepancyGain !== 'number') {
      values.discrepancyGain = Number(values.discrepancyGain);
    }
    if (values.quantityLost !== undefined && typeof values.quantityLost !== 'number') {
      values.quantityLost = Number(values.quantityLost);
    }
    if (values.quantityFound !== undefined && typeof values.quantityFound !== 'number') {
      values.quantityFound = Number(values.quantityFound);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...pharmacyAuditSummaryEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      lossBill: pharmacyBills.find(it => it.id.toString() === values.lossBill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          auditStatus: 'INITIATED',
          auditOutcome: 'SUCCESSFUL',
          ...pharmacyAuditSummaryEntity,
          pharmacy: pharmacyAuditSummaryEntity?.pharmacy?.id,
          lossBill: pharmacyAuditSummaryEntity?.lossBill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyAuditSummary.home.createOrEditLabel" data-cy="PharmacyAuditSummaryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditSummary.home.createOrEditLabel">
              Create or edit a PharmacyAuditSummary
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-audit-summary-id"
                  label={translate('tinyMedicRestApp.pharmacyAuditSummary.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.startDate')}
                id="pharmacy-audit-summary-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.endDate')}
                id="pharmacy-audit-summary-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.discrepancyLoss')}
                id="pharmacy-audit-summary-discrepancyLoss"
                name="discrepancyLoss"
                data-cy="discrepancyLoss"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.discrepancyGain')}
                id="pharmacy-audit-summary-discrepancyGain"
                name="discrepancyGain"
                data-cy="discrepancyGain"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.quantityLost')}
                id="pharmacy-audit-summary-quantityLost"
                name="quantityLost"
                data-cy="quantityLost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.quantityFound')}
                id="pharmacy-audit-summary-quantityFound"
                name="quantityFound"
                data-cy="quantityFound"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.auditStatus')}
                id="pharmacy-audit-summary-auditStatus"
                name="auditStatus"
                data-cy="auditStatus"
                type="select"
              >
                {auditStatusValues.map(auditStatus => (
                  <option value={auditStatus} key={auditStatus}>
                    {translate(`tinyMedicRestApp.AuditStatus.${auditStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.auditOutcome')}
                id="pharmacy-audit-summary-auditOutcome"
                name="auditOutcome"
                data-cy="auditOutcome"
                type="select"
              >
                {auditOutcomeValues.map(auditOutcome => (
                  <option value={auditOutcome} key={auditOutcome}>
                    {translate(`tinyMedicRestApp.AuditOutcome.${auditOutcome}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.active')}
                id="pharmacy-audit-summary-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.microSec')}
                id="pharmacy-audit-summary-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.lastupdated')}
                id="pharmacy-audit-summary-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.timestampentry')}
                id="pharmacy-audit-summary-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.cursor')}
                id="pharmacy-audit-summary-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.newSync')}
                id="pharmacy-audit-summary-newSync"
                name="newSync"
                data-cy="newSync"
                check
                type="checkbox"
              />
              <ValidatedField
                id="pharmacy-audit-summary-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-audit-summary-lossBill"
                name="lossBill"
                data-cy="lossBill"
                label={translate('tinyMedicRestApp.pharmacyAuditSummary.lossBill')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-audit-summary" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyAuditSummaryUpdate;
